import ClickAwayListener from '@mui/material/ClickAwayListener';

import React from 'react';

const isClickInsideElement = (event, elementRef) => {
  if (!elementRef.current) {
    return false;
  }
  const rect = elementRef.current.getBoundingClientRect();
  const { clientX, clientY } = event;

  return (
    clientX >= rect.left &&
    clientX <= rect.right &&
    clientY >= rect.top &&
    clientY <= rect.bottom
  );
};

const CustomClickAwayListener = ({ children, onClickAway, safeRefs = [] }) => {
  const handleClickAway = (event) => {
    for (let i = 0; i < safeRefs.length; i += 1) {
      const ref = safeRefs[i];
      if (ref.current) {
        // First, perform a standard DOM containment check
        if (ref.current.contains(event.target)) {
          return;
        }
        // If that fails, perform a more robust positional check
        if (isClickInsideElement(event, ref)) {
          return;
        }
      }
    }
    // If the click is not inside any of the safe elements, call onClickAway
    onClickAway(event);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      {children}
    </ClickAwayListener>
  );
};

export default CustomClickAwayListener;
